export default "__VITE_ASSET__CxTr6WKL__"